<template>
  <v-expansion-panel
    class="event-panel"
    @change="$emit('toggle')"
  >
    <v-expansion-panel-header
      hide-actions
      :class="['event-panel__header', {active: expanded}]"
    >
      <template>
        <v-icon
          size="16"
          color="black"
          class="mx-4"
          style="flex:none"
        >
          {{ expanded ? '$faChevronDown' : '$faChevronRight' }}
        </v-icon>
        <div class="event-info">
          <div class="event-info__property-name">
            <router-link
              class="link"
              :to="{ name: 'Property Details', params: {id: `${property.id}`}}"
            >
              {{ property.name }}
            </router-link>
          </div>
          <div class="event-number">
            {{ propertyEvents.length }} {{ propertyEvents.length > 1 ? 'Events' : 'Event' }}
          </div>
          <div class="event-duration">
            Last Alert: {{ mostRecentEventDelay | formatDuration }} ago
          </div>
        </div>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="event-panel__content">
      <list-events-on-property :event-list="propertyEvents" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
  import { DateTime } from 'luxon'
  import ListEventsOnProperty from '@/components/landing/ListEventsOnProperty.vue'

  const minutes = 60 * 1000
  const hours = 60 * minutes
  const days = 24 * hours

  export default {
    name: 'LiveEventsListItem',
    components: { ListEventsOnProperty },
    filters: {
      formatDuration (value) {
        const duration = Math.abs(value.valueOf())
        const wholeDays = Math.floor(duration / days)
        const wholeHours = Math.floor((duration - wholeDays * days) / hours)
        const wholeMinutes = Math.floor((duration - wholeDays * days - wholeHours * hours) / minutes)
        let durationText = ''
        if (wholeDays !== 0) durationText += `${wholeDays}d` + ' '
        if (wholeHours !== 0) durationText += `${wholeHours}h` + ' '
        if (wholeMinutes !== 0) durationText += `${wholeMinutes}m`
        return durationText
      },
    },
    props: {
      property: {
        type: Object,
        default () { return { id: '', name: '' } },
      },
      propertyEvents: Array,
      expanded: Boolean,
    },
    computed: {
      mostRecentEventDelay () {
        const isInProgress = (evt) => !evt.utcEndDateTime
        const initialEvent = this.propertyEvents[0]
        if (isInProgress(initialEvent)) return DateTime.fromISO(initialEvent.utcStartDateTime).diffNow()
        else {
          let mostRecentEvent = initialEvent
          for (const evt of this.propertyEvents.slice(1)) {
            if (isInProgress(evt)) return DateTime.fromISO(evt.utcStartDateTime).diffNow()
            const dateTime = DateTime.fromISO(evt.utcStartDateTime)
            const mostRecentEventDateTime = DateTime.fromISO(mostRecentEvent.utcStartDateTime)
            if (dateTime.diff(mostRecentEventDateTime).valueOf() > 0) {
              mostRecentEvent = evt
            }
          }
          return DateTime.fromISO(mostRecentEvent.utcStartDateTime).diffNow()
        }
      },
    },
  }
</script>

<style lang="scss">
.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: transparent;
  &::before {
    box-shadow: unset;
    transition: unset;
  }
}
.event-panel + .event-panel {
    margin-top: 11px;
}
.event-panel__header {
    height: 81px;
    padding: 10px 0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: white;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    align-items: center;

  &.active {
    box-shadow: 0px 1px 8px rgba(60, 51, 51, 0.61);
    transition: border-top 100ms ease-in;
    border-top: 4px solid $na-light-purple;
    font-weight: bold;
  }

  .event-info {
    width: calc(100% - 48px);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    padding-right: 16px;
  }

  .event-info__property-name {
    flex: 0 0 auto;
    width: 33.33%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      & .link {
        font-weight: 700;
        color: $muted;
        letter-spacing: 0.19px;
        font-size: 16px;
        text-decoration:none;
        &:hover {
          text-decoration: underline;
        }
      }
  }
  .event-number {
    flex: 0 0 33.33%;
    color: $base;
    font-size: 15px;
  }

  .event-duration {
    flex: 0 0 33.33%;
    font-size: 15px;
    color: $base;
    white-space: nowrap;
    text-align: right;
  }
}
  .event-panel__content {
    width: calc(100% - 19px);
    margin: auto;
    background-color: white;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.0927939);
    border-radius: 4px;
  }
</style>
